<template>
  <div class="getter-test-page">
    <AdminMenu />

    <el-card class="m-2">
      <el-row>
        <el-col :span="8">
          <el-button-group>
            <el-button @click="onHideAll">Hide all</el-button>
            <el-button @click="onShowAll">Show all</el-button>
          </el-button-group>
        </el-col>
        <el-col :span="16">
          <el-form label-position="right" label-width="100px">
            <el-form-item label="Goal ID:" class="mb-0">
              <el-input size="small" v-model="goal_id"></el-input>
            </el-form-item>
            <el-form-item label="Effort ID:" class="mb-0">
              <el-input size="small" v-model="effort_id" placeholder="Effort ID"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="m-2">
      <div slot="header">
        <h3 class="m-0">Goal Getters</h3>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(0)">goal_load_list</span>
      <div v-if="show[0]">
        <pre>{{goal_load_list}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(1)">goal_list_ids</span>
      <div v-if="show[1]">
        <pre>{{goal_list_ids}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(2)">goal_list_state</span>
      <div v-if="show[2]">
        <pre>{{goal_list_state}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(3)">goal_list_meta_ready_with_deleted</span>
      <div v-if="show[3]">
        <pre>{{goal_list_meta_ready_with_deleted}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(4)">goal_list_meta_ready_without_deleted</span>
      <div v-if="show[4]">
        <pre>{{goal_list_meta_ready_without_deleted}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(5)">all_goals_are_ready</span>
      <div v-if="show[5]">
        <pre>{{all_goals_are_ready}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(6)">num_of_goals_ready</span>
      <div v-if="show[6]">
        <pre>{{num_of_goals_ready}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(7)">goal_is_ready( goal_id )</span>
      <div v-if="show[7]">
        <pre>{{goal_is_ready( goal_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(8)">goal_is_deleted( goal_id )</span>
      <div v-if="show[8]">
        <pre>{{goal_is_deleted( goal_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(9)">goal_by_id( goal_id )</span>
      <div v-if="show[9]">
        <pre>{{goal_by_id( goal_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(10)">unsorted_tasks( goal_id )</span>
      <div v-if="show[10]">
        <pre>{{unsorted_tasks( goal_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(11)">sorted_tasks( goal_id )</span>
      <div v-if="show[11]">
        <pre>{{sorted_tasks( goal_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(12)">get_lanes_by_goal_id( goal_id )</span>
      <div v-if="show[12]">
        <pre>{{get_lanes_by_goal_id( goal_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(13)">get_lanes_with_tasks_grouped( goal_id )</span>
      <div v-if="show[13]">
        <pre>{{get_lanes_with_tasks_grouped( goal_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(14)">get_tasks_flat_without_parent( goal_id )</span>
      <div v-if="show[14]">
        <pre>{{get_tasks_flat_without_parent( goal_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(15)">get_lanes_by_goal_id_without_deleted( goal_id )</span>
      <div v-if="show[15]">
        <pre>{{get_lanes_by_goal_id_without_deleted( goal_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(16)">get_lanes_by_goal_id_without_deleted( goal_id )</span>
      <div v-if="show[16]">
        <pre>{{get_lanes_by_goal_id_without_deleted( goal_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(17)">get_tasks_flat_with_parent( goal_id, lane_id )</span>
      <div v-if="show[17]">
        <pre>{{get_tasks_flat_with_parent( goal_id, lane_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(18)">get_task_by_goal_id_and_task_id( goal_id, lane_id )</span>
      <div v-if="show[18]">
        <pre>{{get_task_by_goal_id_and_task_id( goal_id, lane_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(19)">get_tasks_by_goal_id_and_lane_id( goal_id, lane_id )</span>
      <div v-if="show[19]">
        <pre>{{get_tasks_by_goal_id_and_lane_id( goal_id, lane_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(20)">checklist_items_by_goal_id_and_task_id( goal_id, lane_id )</span>
      <div v-if="show[20]">
        <pre>{{checklist_items_by_goal_id_and_task_id( goal_id, lane_id )}}</pre>
      </div>

      <!--
      <span class="dev-getter-exec todo" @click="toggle(21)">XXX( goal_id, lane_id )</span>
      <div v-if="show[21]">
        <pre>{{XXX( goal_id, lane_id )}}</pre>
      </div>
      -->

    </el-card>

    <el-card class="m-2">
      <div slot="header">
        <h3 class="m-0">Effort Getters</h3>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(22)">effort_list_all</span>
      <div v-if="show[22]">
        <pre>{{effort_list_all}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(23)">effort_list_by_goal_id( goal_id )</span>
      <div v-if="show[23]">
        <pre>{{effort_list_by_goal_id( goal_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(24)">effort_by_effort_id( effort_id )</span>
      <div v-if="show[24]">
        <pre>{{effort_by_effort_id( effort_id )}}</pre>
      </div>

      <span class="dev-getter-exec todo" @click="toggle(25)">effort_by_goal_id_and_effort_id( goal_id, effort_id )</span>
      <div v-if="show[25]">
        <pre>{{effort_by_goal_id_and_effort_id( goal_id, effort_id )}}</pre>
      </div>

    </el-card>
  </div>
</template>

<script>
import AdminMenu from './Elements/AdminMenu'
import { mapGetters } from 'vuex'

/*
{
  goal_load_list:                             this.goal_load_list,
  goal_list_ids:                              this.goal_list_ids,
  goal_list_state:                            this.goal_list_state,
  goal_list_meta_ready_with_deleted:          this.goal_list_meta_ready_with_deleted,
  goal_list_meta_ready_without_deleted:       this.goal_list_meta_ready_without_deleted,
  all_goals_are_ready:                        this.all_goals_are_ready,
  num_of_goals_ready:                         this.num_of_goals_ready,
  task_id_to_goal_id_cache:                   this.task_id_to_goal_id_cache,
  goal_is_ready:                              this.goal_is_ready( id ),
  goal_is_deleted:                            this.goal_is_deleted( id ),
  goal_by_id:                                 this.goal_by_id( id ),
  unsorted_tasks:                             this.unsorted_tasks( id ),
  sorted_tasks:                               this.sorted_tasks( id ),
  get_lanes_by_goal_id:                       this.get_lanes_by_goal_id( goal_id ),
  get_lanes_with_tasks_grouped:               this.get_lanes_with_tasks_grouped( goal_id ),
  get_tasks_flat_without_parent:              this.get_tasks_flat_without_parent( goal_id ),
  get_lanes_by_goal_id_without_deleted:       this.get_lanes_by_goal_id_without_deleted( goal_id ),
  get_tasks_flat_with_parent:                 this.get_tasks_flat_with_parent( goal_id, lane_id ),
  get_task_by_goal_id_and_task_id:            this.get_task_by_goal_id_and_task_id( goal_id, task_id ),
  get_tasks_by_goal_id_and_lane_id:           this.get_tasks_by_goal_id_and_lane_id( goal_id, lane_id ),
  checklist_items_by_goal_id_and_task_id:     this.checklist_items_by_goal_id_and_task_id( goal_id, task_id ),
}
{
  effort_list_all:                            this.effort_list_all,
  effort_list_by_goal_id:                     this.effort_list_by_goal_id(goalId),
  effort_by_effort_id:                        this.effort_by_effort_id(commitmentId),
  effort_by_goal_id_and_effort_id:            this.effort_by_goal_id_and_effort_id(goalId, commitmentId),
}
*/

export default {
  data() {
    let show = new Array( 25 ).fill(false);
    return {
      show: show,
      goal_id: 'LPu4sVrRRI2gAbPnjSMIVA',
      lane_id: 'VDLLLJXfRIarUQiJKSGp9g',
      effort_id: 'VDLLLJXfRIarUQiJKSGp9g',
    }
  },
  computed: {
    ...mapGetters("goal",[
      'goal_load_list',
      'goal_list_ids',
      'goal_list_state',
      'goal_list_meta_ready_with_deleted',
      'goal_list_meta_ready_without_deleted',
      'all_goals_are_ready',
      'num_of_goals_ready',
      'task_id_to_goal_id_cache',
      'goal_is_ready',
      'goal_is_deleted',
      'goal_by_id',
      'unsorted_tasks',
      'sorted_tasks',
      'get_lanes_by_goal_id',
      'get_lanes_with_tasks_grouped',
      'get_tasks_flat_without_parent',
      'get_lanes_by_goal_id_without_deleted',
      'get_tasks_flat_with_parent',
      'get_task_by_goal_id_and_task_id',
      'get_tasks_by_goal_id_and_lane_id',
      'checklist_items_by_goal_id_and_task_id',
    ]),
    ...mapGetters("effort",[
      'effort_list_by_goal_id',
      'effort_list_all',
      'effort_by_effort_id',
      'effort_by_goal_id_and_effort_id',
    ]),
  },
  methods: {
    toggle( idx ) {
      this.$set(this.show, idx, !this.show[idx])
    },
    onShowAll() {
      this.show = this.show.map(() => true)
    },
    onHideAll() {
      this.show = this.show.map(() => false)
    }
  },
  components: {
    AdminMenu
  }
};
</script>

<style scoped>
.dev-getter-exec {
  display: block;
  color: blue;
  margin: 4px 0;
  cursor: pointer;
  font-family: monospace;
}
.dev-getter-exec.todo {
  color: red;
}
.dev-getter-exec:hover {
  font-weight: bold;
}
.getter-test-page pre {
  font-size: 9pt;
  padding: 0.5em;
  border: 1px solid gray;
}
</style>
